import { Component, Injector } from '@angular/core';
import { ViewController, NavParams, LoadingController } from "ionic-angular";
import { Util } from '../../app/util';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'page-detail_badge',
  templateUrl: 'detail_badge.html',
})
export class DetailBadge extends Util {
  testo: string;
  img_data: any;
  badge: any;
  constructor(public viewCtrl: ViewController, public navpar: NavParams, public inj: Injector, loading: LoadingController,public translate:TranslateService) {
    super(inj, loading);
    // this.testo = this.navpar.get('testo');
    // this.img_data = this.navpar.get('img_data'); 
    this.badge = this.navpar.get('testo');
  }

  response(res) {
    this.viewCtrl.dismiss(res);
  }
  scarica() {
    // console.log(this.badge);
    this.GetRequest('linkBadge', this.badge.identfier).then((x: any) => {
      if (x != null && x.pdf != null) {
        const linkSource = `data:application/pdf;base64,${x.pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = x.filename;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }

    }).catch((err) => {
      console.log(err);
    });




    //this.open_in_app_browser(this.urlserver+ 'linkBadge/'+ this.badge.identfier);
  }
}


// WEBPACK FOOTER //
// ./src/pages/detail_badge/detail_badge.ts